import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CommonFeatureEntryInterface } from 'src/app/model/commonFeature/common-feature-entry-interface';
import { CommonFeatureInterface } from 'src/app/model/commonFeature/common-feature-interface';
import { ProductCommonFeatureInterface } from 'src/app/model/commonFeature/product-common-feature-interface';
import { CommonFeatureService } from 'src/app/services/common-feature-service/common-feature.service';

@Component({
    selector: 'app-dialog-common-feature-product-creation',
    templateUrl: './dialog-common-feature-product-creation.component.html',
    styleUrls: [
        './dialog-common-feature-product-creation.component.css',
        '../dialog.css'
    ],
    standalone: false
})
export class DialogCommonFeatureProductCreationComponent implements OnInit {
    public allCommonFeatures: CommonFeatureInterface[] = [];
    public availableCommonFeatures: CommonFeatureInterface[] = [];
    public selectedCommonFeatures: ProductCommonFeatureInterface[] = [];
    public shownSelectedFeatures: ProductCommonFeatureInterface[] = [];
    public expandedFeature: boolean[] = [];
    availableFeatureSearch: string = '';
    selectedFeatureSearch: string = '';

    constructor(
        public dialogRef: MatDialogRef<DialogCommonFeatureProductCreationComponent>,
        @Inject(MAT_DIALOG_DATA) public data: string,
        private commonFeatureService: CommonFeatureService
    ) {
        this.selectedCommonFeatures = this.data['selected'];
    }

    ngOnInit(): void {
        this.commonFeatureService
            .getAllFeatures()
            .subscribe((success: CommonFeatureInterface[]) => {
                this.allCommonFeatures = success;
                this.updateAvailableCommonFeature();
                this.updateShownSelectedCommonFeatures();
            });
    }

    /* Toggles whether the Entries of a Feature should be visible */
    public toggleFeatureExpand(index: number): void {
        this.expandedFeature[index] = !this.expandedFeature[index];
    }

    /* Selects the Entry of an Feature */
    public selectFeatureEntry(
        feature: CommonFeatureInterface,
        entry: CommonFeatureEntryInterface
    ): void {
        this.selectedCommonFeatures.push({
            feature: feature,
            entry: entry
        });
        this.updateShownSelectedCommonFeatures();
    }

    /* Closes the Dialog without saving */
    public cancel(): void {
        this.dialogRef.close();
    }

    /* Clears the SearchText for available Features */
    public clearSearchText(): void {
        this.availableFeatureSearch = '';
        this.updateAvailableCommonFeature();
    }

    /* Clears the SearchText for selected Features */
    public clearSearchTextSelected(): void {
        this.selectedFeatureSearch = '';
        this.updateShownSelectedCommonFeatures();
    }

    /* Removes Feature from the Selected Feature List */
    public removeSelectedFeature(index: number): void {
        this.selectedCommonFeatures.splice(index, 1);
        this.updateShownSelectedCommonFeatures();
    }

    /* Saves the currently selected Features */
    public save(): void {
        this.dialogRef.close(this.selectedCommonFeatures);
    }

    /**
     * Removes all already selected feature Entries from the given list of featureEntries.
     * Used to remove already selected entries in the "available" colmn expanded Features.
     *
     * @param featureEntries
     */
    removeSelectedEntriesFrom(featureEntries: CommonFeatureEntryInterface[]) {
        let selectedFeatureEntries = this.selectedCommonFeatures.map(
            (x) => x.entry
        );
        return featureEntries.filter((featureEntry) => {
            return (
                selectedFeatureEntries.findIndex(
                    (x) => featureEntry.id == x.id
                ) < 0
            );
        });
    }

    public updateAvailableCommonFeature(): void {
        this.availableCommonFeatures = [];
        this.expandedFeature = [];

        this.allCommonFeatures.forEach((feature) => {
            if (
                this.doesTextIncludeSearchText(
                    feature.name,
                    this.availableFeatureSearch
                ) ||
                feature.featureEntries.some((entry) =>
                    this.doesTextIncludeSearchText(
                        entry.name,
                        this.availableFeatureSearch
                    )
                )
            ) {
                this.availableCommonFeatures.push(feature);
                this.expandedFeature.push(false);
            }
        });
    }

    public updateShownSelectedCommonFeatures(): void {
        this.shownSelectedFeatures = [];

        this.selectedCommonFeatures.forEach((selected) => {
            if (
                this.doesTextIncludeSearchText(
                    selected.feature.name,
                    this.selectedFeatureSearch
                ) ||
                this.doesTextIncludeSearchText(
                    selected.entry.name,
                    this.selectedFeatureSearch
                )
            ) {
                this.shownSelectedFeatures.push(selected);
            }
        });
    }

    private doesTextIncludeSearchText(
        text: string,
        searchText: string
    ): boolean {
        return text.toLowerCase().includes(searchText.toLowerCase());
    }
}
